import React from 'react';
import { Badge, CardBody, CardTitle } from 'reactstrap';
import cls from 'classnames';
import { Droppable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEraser } from '@fortawesome/free-solid-svg-icons';

export default class DailyAttendanceEventCard extends React.Component {
    getStaffCount = () => {
        const { dailyAttendanceEvent, employeeDailyAttendanceEvents } = this.props;

        return employeeDailyAttendanceEvents.filter(
            (edae) => edae.dailyAttendanceEventId == dailyAttendanceEvent.id,
        ).length;
    };

    getBackgroundColor = (snapshot) => {
        if (!snapshot.isDraggingOver) {
            return '';
        }

        const { dailyAttendanceEvent } = this.props;

        return dailyAttendanceEvent.isRemove ? 'LightCoral' : 'LightSteelBlue';
    };

    handleClick = () => {
        const { onClick, dailyAttendanceEvent } = this.props;

        if (onClick) {
            onClick(dailyAttendanceEvent.id);
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleClick(e);
        }
    };

    render() {
        const { dailyAttendanceEvent, isSelected } = this.props;

        if (!dailyAttendanceEvent) {
            return null;
        }

        const staffCount = this.getStaffCount();

        return (
            <div
                className={cls('card dailyAttendanceEventCard compact', {
                    selected: isSelected,
                })}
                data-event-id={dailyAttendanceEvent.id}
                onClick={this.handleClick}
                onKeyDown={this.handleKeyDown}
                role="button"
                tabIndex={0}
            >
                <Droppable
                    key={`dailyAttendanceEvent_${dailyAttendanceEvent.id}`}
                    droppableId={`dailyAttendanceEvent_${dailyAttendanceEvent.id}`}
                >
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                                backgroundColor: this.getBackgroundColor(snapshot),
                            }}
                        >
                            <CardBody>
                                <CardTitle
                                    data-text={`${dailyAttendanceEvent.name}`}
                                    className="text-left"
                                >
                                    {`${dailyAttendanceEvent.name}`}
                                </CardTitle>
                                <span className="title-separator" />
                                {!dailyAttendanceEvent.isRemove && (
                                    <Badge className="badge-bigger">
                                        {staffCount}
                                    </Badge>
                                )}
                                {dailyAttendanceEvent.isRemove && (
                                    <FontAwesomeIcon
                                        className="remove-icon"
                                        icon={faEraser}
                                    />
                                )}
                                {provided.placeholder}
                            </CardBody>
                        </div>
                    )}
                </Droppable>
            </div>
        );
    }
}
